import React from 'react';
import { programContent } from '@/data/staticProgramData';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './WhatsAppFloat.scss';

const WhatsAppFloat = () => {
  const { phone, message, label } = programContent.whatsapp;
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      title={label}
    >
      <i className="fa-brands fa-whatsapp whatsapp-float__icon" aria-hidden="true" />
    </a>
  );
};

export default WhatsAppFloat;
